import React, { useState, useRef, useEffect } from "react";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "./TH.css";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import { uploadTHFile, closeAlert } from "../Redux/THSlice";
import { getCurrentMonth } from "../Redux/BussinessPOCSlice";
import { Typography } from "@mui/material";
import { Alert } from "@mui/material";
function TLFileUpload() {
 const [selectedMonth, setSelectedMonth] = useState(null);
 const [selectedYear, setSelectedYear] = useState(null);

 const [file, setFile] = useState("");
 const [errorMessage, setErrorMessage] = useState("");
 const [loading, setLoading] = useState(false);

 const response = useSelector((state) => state.traininghost.responseMessage);
 const isUploaded = useSelector((state) => state.traininghost.isUploaded);
 const dispatch = useDispatch();

 const ref = useRef();
 const saveFile = (e) => {
  setErrorMessage("");

  setFile(e.target.files[0]);
 };
 const handledateChange = (value) => {
  const date = new Date(value.$d);

  const month = date.getMonth() + 1; // Months are zero-based, so add 1
  const year = date.getFullYear();
  const monthNames = [
   "January",
   "February",
   "March",
   "April",
   "May",
   "June",
   "July",
   "August",
   "September",
   "October",
   "November",
   "December",
  ];
  const selectedMonthName = monthNames[month - 1];
  setSelectedMonth(selectedMonthName);
  setSelectedYear(year);
 };

 const handleUpload = () => {
  if (!file) {
   setErrorMessage("Please select a file.");
   return;
  }
  const formData = new FormData();
  formData.append("file", file);
  dispatch(uploadTHFile(formData, selectedMonth, selectedYear));
 };
 useEffect(() => {
  dispatch(getCurrentMonth());
 }, []);
 return (
  <div>
   <Box>
    {isUploaded ? (
     <Alert
      style={{
       maxWidth: "fit-content",
       position: "fixed",
       top: "100px",
       right: "0px",
       backgroundColor: isUploaded ? "#05f0a5" : "#ff3246",
       color: "white",
      }}
      onClose={() => {
       dispatch(closeAlert());
      }}
     >
      {response}
     </Alert>
    ) : null}

    <Stack spacing={2} direction={"row"} alignItems={"center"}>
     <Typography sx={{ fontSize: "14px", fontWeight: "700" }}>Choose Month:</Typography>
     <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
       className="calendar"
       sx={{ minWidth: "80px" }}
       onChange={(newValue) => handledateChange(newValue)}
       views={["month"]}
      />
      {/* </DemoContainer> */}
     </LocalizationProvider>
     <input
      type="file"
      className="th-mainData"
      accept=".xlsx"
      ref={ref}
      id="file"
      onChange={saveFile}
      name="file"
      hidden
     />
     <label for="file" className="th-mainData">
      Select File
     </label>
     <span className="th-file_caption">
      {file.name != undefined && file.name != null ? file.name : "No File Selected"}
     </span>
     <Button
      className={
       loading === false
        ? "th-upload_button_modal_active"
        : "th-upload_button_modal_inactive"
      }
      sx={{ minWidth: "30px !important" }}
      onClick={handleUpload}
     >
      Upload
     </Button>
    </Stack>
   </Box>
  </div>
 );
}

export default TLFileUpload;
